import type { AuthState } from '@/redux/auth/AuthReducer';
import { useQuery } from '@tanstack/react-query';
import { shallowEqual, useSelector } from 'react-redux';
import { fetchQuoteModuleSettings } from '../data-provider/quote-module-settings';

export const useGetQuoteModuleSettings = () => {
  const companyId = useSelector((state: AuthState) => state.auth.selectedCompany.companyId, shallowEqual);

  return useQuery({
    queryKey: ['quoteModuleSettings', companyId],
    queryFn: fetchQuoteModuleSettings,
    staleTime: 1000 * 10 * 60,
  });
};
